module.exports = __webpack_public_path__ + "img/3rUw5nLdRFBK92P8ztuOo.98ec7523.svg";